import React from 'react';
import { Box } from '@mui/material';
import { Pie } from 'react-chartjs-2';
import './style.css';

const TopPlatforms = ({ top_platforms, title }) => {
	const MAX_COLORS = 5;
	const colors = [
		'#d0315e',
		'#F66E7F',
		'#FAB293',
		'#A04377',
		'#FBEAE4',
		'#FAB293',
	];

	// Validar dados antes de renderizar
	if (!top_platforms || !Array.isArray(top_platforms) || top_platforms.length === 0) {
		return (
			<>
				<h5 className='title' align='left'>
					{title}
				</h5>
				<Box m={2} />
				<p>Nenhum dado disponível</p>
			</>
		);
	}

	// Filtrar plataformas válidas e garantir que platform é uma string
	const validPlatforms = top_platforms.filter(
		(platform) => platform && platform.platform && typeof platform.platform === 'string'
	);

	if (validPlatforms.length === 0) {
		return (
			<>
				<h5 className='title' align='left'>
					{title}
				</h5>
				<Box m={2} />
				<p>Nenhum dado válido disponível</p>
			</>
		);
	}

	const sortedPlatforms = [...validPlatforms].sort((a, b) => (b.share || 0) - (a.share || 0));
	const displayedPlatforms = sortedPlatforms.slice(0, MAX_COLORS);

	// Função para aumentar a intensidade da cor (efeito de hover)
	function intensifyColor(color, amount) {
		const colorNum = parseInt(color.slice(1), 16);
		const r = Math.min(((colorNum >> 16) & 0xff) + amount, 255);
		const g = Math.min(((colorNum >> 8) & 0xff) + amount, 255);
		const b = Math.min((colorNum & 0xff) + amount, 255);
		const newColorNum = (b | (g << 8) | (r << 16)) >>> 0;
		return '#' + newColorNum.toString(16).padStart(6, '0');
	}
	const data = {
		labels: displayedPlatforms.map((item) => item.platform),
		datasets: [
			{
				data: displayedPlatforms.map((item) => item.share),
				backgroundColor: colors.slice(0, displayedPlatforms.length),
				hoverBorderColor: colors
					.slice(0, displayedPlatforms.length)
					.map((color) => intensifyColor(color, 20)),
			},
		],
	};

	const options = {
		tooltips: {
			callbacks: {
				label: function (tooltipItem, data) {
					if (!data || !data.datasets || !data.labels) {
						return '';
					}
					const dataset = data.datasets[tooltipItem.datasetIndex];
					if (!dataset || !dataset.data) {
						return '';
					}
					const percentage = (dataset.data[tooltipItem.index] || 0).toFixed(1);
					const label = data.labels[tooltipItem.index] || '';
					return `${label}: ${percentage}%`;
				},
			},
		},
	};

	// Gerar uma key única baseada nos dados para forçar recriação do gráfico
	const chartKey = displayedPlatforms.map(p => p.platform).join('-');

	return (
		<>
			<h5 className='title' align='left'>
				{title}
			</h5>
			<Box m={2} />

			<Pie key={chartKey} data={data} options={options} />
		</>
	);
};

export default TopPlatforms;
